module.exports = __webpack_public_path__ + "static/media/25-mercedes.50aa566a.jpg";